import React from "react";
import bg_image from "../../assets/images/comparison_bg.svg";
import homeIcon from "../../assets/images/homeicon_compare.svg";
import ABOUT_DATA from "../../utils/aboutData";
import RightContainer from "./RightContainer";
import LeftContainer from "./LeftContainer";
import FindBestTransferRates from "./FindBestTransferRates";

export default function AboutPage() {
  return (
    <div className="mt-[60px] sm:mt-[50px] mx-auto sm:px-0">
      {/* Hero Section */}
      <div
        className="bg-cover bg-center text-white p-6 md:p-12 "
        style={{ backgroundImage: `url(${bg_image})` }}
      >
        <div className="flex items-center text-sm md:text-base font-semibold">
          <img src={homeIcon} alt="/home-icon" className="mr-2" />
          <span>/ About</span>
        </div>

        <div className="max-w-3xl mx-auto text-center sm:mt-[50px]">
          <h1 className="text-3xl md:text-8xl font-bold mb-6">About Us</h1>
          <h2 className="text-2xl md:text-4xl font-bold mb-6">
            {ABOUT_DATA.about_heading}
          </h2>
          <p className="text-sm md:text-base lg:font-[600]"></p>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex mt-[30px] sm:mt-[70px] mx-[20px] sm:mx-[50px] gap-[40px]">
        <div className="sm:w-[70%]">
          <LeftContainer />
        </div>
        <div className="md:w-[30%] hidden md:block">
          <RightContainer />
        </div>
      </div>
      <FindBestTransferRates />
    </div>
  );
}
